export default __webpack_public_path__ + "static/media/cross6.a75923c3.svg";